// extracted by mini-css-extract-plugin
export default {"item":"SymptomItem_item__yZsfq","checkbox":"SymptomItem_checkbox__J08Xd"};